import { z } from "zod";
import { unformat } from "v-money3";
import { MINIMUM_APPOINTMENT_PRICE } from "@/constants";

export const profileAboutSchema = z.object({
  education: z.string().min(1, "Informe sua formação"),
  years_exp: z.string().min(1, "Informe sua experiência"),
  crp: z.string().min(4, "Informe um CRP válido"),
  epsi: z.string(),
  bio: z.string().min(1, "Informe uma descrição"),
});
export type ProfileAboutValues = z.infer<typeof profileAboutSchema>;

const MAX_APPOINTMENT_PRICE = 9999;
const moneyConfig = {
  prefix: "R$ ",
  thousands: "",
  decimal: ",",
  precision: 2,
};
const appointmentPriceRangeMsg = `Informe um valor entre R$${MINIMUM_APPOINTMENT_PRICE},00 e R$${MAX_APPOINTMENT_PRICE},00`;

const isPriceInRange = (v: string | number) => {
  const n = unformat(String(v), moneyConfig) as number;
  return n >= MINIMUM_APPOINTMENT_PRICE && n <= MAX_APPOINTMENT_PRICE;
};

const isPriceInRangeOrEmpty = (v: string | number) => {
  if (!v) return true;
  return isPriceInRange(v);
};

export const appointmentPriceSchema = z.object({
  appointment_price: z.any().refine(isPriceInRange, appointmentPriceRangeMsg),
  first_appointment_price: z
    .any()
    .refine(isPriceInRange, appointmentPriceRangeMsg),
  recurrent_price: z
    .any()
    .optional()
    .refine(isPriceInRangeOrEmpty, appointmentPriceRangeMsg),
});
export type AppointmentPriceValues = z.infer<typeof appointmentPriceSchema>;

export const approachesSchema = z.object({
  approaches: z
    .array(z.number())
    .min(1, "Selecione até 6 especialidades"),
});
export type ApproachesValues = z.infer<typeof approachesSchema>;

export const genderSchema = z.object({
  gender: z.string(),
  accepted_gender: z.string(),
});
export type GenderValues = z.infer<typeof genderSchema>;

export const introVideoSchema = z.object({
  intro_video_link: z.string().min(1, "Informe um link válido"),
});
export type IntroVideoValues = z.infer<typeof introVideoSchema>;

export const languagesSchema = z.object({
  languages: z.array(z.number()),
});
export type LanguagesValues = z.infer<typeof languagesSchema>;

export const reportRatingSchema = z.object({
  reason_report: z.string().min(1, "Informe por qual motivo deseja reportar"),
});
export type ReportRatingValues = z.infer<typeof reportRatingSchema>;

export const specialtiesSchema = z.object({
  occupation_areas: z
    .array(z.number())
    .min(1, "Selecione até 6 especialidades"),
});
export type SpecialtiesValues = z.infer<typeof specialtiesSchema>;
